import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import _ from "lodash";
import Select from "react-select";
import { getAll } from "../../../actions/incomesAction";
import i18n from "../../../lib/i18n/i18n";
import UseLoadStudents from "../../useComponents/UseLoadStudents";
import { getBranches } from "../../../actions/branchActions";
import Button from "../../UiComponents/Buttons/Default";
import { getStudents } from "../../../actions/studentesActions";
import { getAllSchoolTestsEvents } from "../../../actions/schedulerActions";
import {
  Row,
  FieldText,
  Field,
  customStyles,
  Container,
} from "./NewStudentsVSInvoices.styles";
import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  Tooltip,
  Line,
  XAxis,
} from "recharts";

const ActivityReport = ({
  isLoading,
  getStudents,
  students,
  getAllSchoolTestsEvents,
  getBranches,
  getAll,
  incomes,
}) => {
  const [graphData, setGraphData] = useState([]);
  const [events, setEvents] = useState([]);
  const [currentView, setCurrentView] = useState("bymonths");
  const [startDate, setStartDate] = useState(new Date().setMonth(0));
  const [endDate, setEndDate] = useState(new Date());
  const [selectedTeacher, setSelectedTeacher] = useState();
  const [selectOptions, setSelectOptions] = useState([]);
  const [rawGraphData, setRawGraphData] = useState([]);
  UseLoadStudents(isLoading, getStudents);

  useEffect(() => {
    (async () => {
      await getAll(1);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (students.length > 0 && incomes.length > 0) {
        const data = [];
        for (
          let index = new Date(startDate).getMonth();
          index <= new Date(endDate).getMonth();
          index++
        ) {
          if (currentView === "byVehicles") {
            const uniqueVehicle = _.uniqBy(students, "vehicleNumber");
            const vehicels = uniqueVehicle
              .filter((x) => x.vehicleNumber !== null)
              .map((x) => x.vehicleNumber);
            setSelectOptions(vehicels.map((x) => ({ value: x, label: x })));
            filterByData(vehicels, index, "vehicleNumber", data, students);
          } else if (currentView === "byBranch") {
            const allBranches = await getBranches();
            setSelectOptions(
              allBranches.map((x) => ({ value: x.name, label: x.name }))
            );
            filterByData(allBranches, index, "branchId", data, students, true);
          } else if (currentView === "byUser") {
            const uniqueLicenses = _.uniqBy(students, "createdBy");
            const licenses = uniqueLicenses
              .filter((x) => x.createdBy !== null)
              .map((x) => x.createdBy);
            setSelectOptions(licenses.map((x) => ({ value: x, label: x })));
            filterByData(licenses, index, "createdBy", data, students);
          } else if (currentView === "byTeacher") {
            const uniqueLicenses = _.uniqBy(students, "teacherName");
            const licenses = uniqueLicenses
              .filter((x) => x.teacherName !== null)
              .map((x) => x.teacherName);
            setSelectOptions(licenses.map((x) => ({ value: x, label: x })));
            filterByData(licenses, index, "teacherName", data, students);
          } else {
            setSelectOptions([]);
            const currentMonthFinancialDocuments = incomes.filter(
              (x) =>
                new Date(x.date).getMonth() === index &&
                new Date(x.date).getFullYear() === new Date().getFullYear()
            );
            const totalInvoiceReceipts = currentMonthFinancialDocuments.filter(
              (x) => x.documentType === 0
            ).length;

            const totalInvoices = currentMonthFinancialDocuments.filter(
              (x) => x.documentType === 2
            ).length;
            data.push({
              date: index + 1,
              תלמידים: students.filter(
                (y) =>
                  new Date(y.createDate).getMonth() === index &&
                  new Date(y.createDate).getFullYear() ===
                    new Date().getFullYear()
              ).length,
              חשבוניות: totalInvoiceReceipts + totalInvoices,
            });
          }
        }
        setGraphData(data);
        setRawGraphData(data);
      }
    })();
  }, [startDate, endDate, currentView, students, events]);

  const filterByData = (array, index, param, data, students, isBranch) => {
    for (let j = 0; j < array.length; j++) {
      const element = array[j];
      const currentMonthFinancialDocuments = incomes.filter(
        (x) =>
          new Date(x.date).getMonth() === index &&
          new Date(x.date).getFullYear() === new Date().getFullYear() &&
          x[param === "createdBy" ? "createUsername" : param].toString() ===
            element
      );
      const totalInvoiceReceipts = currentMonthFinancialDocuments.filter(
        (x) => x.documentType === 0
      ).length;
      const totalInvoices = currentMonthFinancialDocuments.filter(
        (x) => x.documentType === 2
      ).length;
      const elementValue = isBranch ? element.id : element;
      data.push({
        date: `${isBranch ? element.name : element} - ${index + 1}`,
        תלמידים: students.filter(
          (y) =>
            new Date(y.createDate).getMonth() === index &&
            new Date(y.createDate).getFullYear() === new Date().getFullYear() &&
            y[param] === elementValue
        ).length,
        חשבוניות: totalInvoiceReceipts + totalInvoices,
      });
    }
  };

  const handleChange = (selected) => {
    setSelectedTeacher(selected);
    if (selected && selected.length > 0) {
      let filteredData = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];

        filteredData = [
          ...filteredData,
          ...rawGraphData.filter((x) => x.date.includes(element.value)),
        ];
      }
      setGraphData(filteredData);
    } else {
      setGraphData(rawGraphData);
    }
  };

  return (
    <Container>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <h1>תלמידים חדשים מול חשבוניות</h1>
        <p>
          תלמידים חדשים כנגד חשבוניות (חשבונית או חשבונית/קבלה) שהונפקו באותו
          החודש
        </p>
      </div>
      <Row>
        <Button
          text="לפי חודשים"
          onClick={() => {
            setCurrentView("byMonths");
          }}
          marginRight="1"
        />
        <Button
          text="לפי רכבים"
          onClick={() => {
            setCurrentView("byVehicles");
          }}
          marginRight="1"
        />
        <Button
          text="לפי יוצר"
          onClick={() => {
            setCurrentView("byUser");
          }}
          marginRight="1"
        />
        <Button
          text="לפי סניפים"
          onClick={() => {
            setCurrentView("byBranch");
          }}
          marginRight="1"
        />
        <>
          <div style={{ width: "33%", marginRight: "1vw" }}>
            <Select
              options={selectOptions}
              value={selectedTeacher}
              isMulti
              placeholder="בחר"
              styles={customStyles}
              onChange={handleChange}
              isRtl
            />
          </div>
          <Field>
            <FieldText>עד</FieldText>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              locale={i18n.language}
              startDate={startDate}
              dateFormat="MMMM"
              endDate={endDate}
              minDate={startDate}
              showMonthYearPicker
              showFullMonthYearPicker
            />
          </Field>
          <Field>
            <FieldText>מ</FieldText>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              locale={i18n.language}
              dateFormat="MMMM"
              showMonthYearPicker
              showFullMonthYearPicker
              selectsStart
              startDate={startDate}
              endDate={endDate}
            />
          </Field>
        </>
      </Row>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={graphData}
          margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
        >
          <XAxis dataKey="date" />
          <Tooltip />
          <CartesianGrid stroke="#f5f5f5" />
          <Line
            type="monotone"
            dataKey="תלמידים"
            stroke="#ff7300"
            yAxisId={0}
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            dataKey="חשבוניות"
            stroke="#387908"
            yAxisId={1}
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Container>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    students: state.StudentsReducer.students,
    isLoading: state.StudentsReducer.isLoaded,
    incomes: state.IncomesReducer.incomes,
  };
}

export default connect(mapStateToProps, {
  getStudents,
  getAllSchoolTestsEvents,
  getBranches,
  getAll,
})(ActivityReport);
